import { AlertController, Platform } from '@ionic/angular';
/** @format */

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { DbService } from '../services/db.service';
import { first } from 'rxjs/operators';
import { AlertService } from 'src/app/services/alert.service';

import { PushService } from '../services/push.service';
import { PlatformchkService } from '../services/platformchk.service';
import { App } from '@capacitor/app';
import { InAppBrowser } from '@capacitor/inappbrowser';
import { AnalyticsService } from '../services/analytics.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public navCtrl: NavController,
    public auth: AuthService,
    public alertController: AlertController,
    private db: DbService,
    public alertService: AlertService,
    private platform: Platform,
    private push: PushService,
    private platformchkService: PlatformchkService,
    private user: UserService,
    private analytics: AnalyticsService,
    private translate: TranslateService,
  ) {}

  uid;
  async ngOnInit() {
  }

  loginCheck = false;

  async loginSet(userInfo) {
    await this.push.getPushId().then(async token => {
      await this.db.updateAt(`user/${userInfo.uid}`, { pushId: token.userId, device: this.user.UUID, })
    });
    var isOnlineForDatabase = {
      state: 'online',
      last_changed: new Date().getTime(),
      devices: this.user.UUID,
    };
    await this.db.updateAt(`status/${userInfo.uid}`, isOnlineForDatabase);
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    //강제버전업 체크 
    if (this.platformchkService.isApp) {
      const versions = await this.db
        .collection$(`version`, ref => ref.where('use', '==', true).orderBy('dateCreated', 'desc'))
        .pipe(first())
        .toPromise();
      if(versions && versions[0]) {
        const lastVersion = versions[0];
        const version = (await App.getInfo()).version;
        if(this.platformchkService.isAndroid) {
          if(parseInt(version.toString().replace(/\./gi, '')) < parseInt(lastVersion.and.replace(/\./gi, ''))) {
            await this.versionUpdate('https://play.google.com/store/apps/details?id=kr.ai.neverland&hl=ko');
          }
        }
        if(this.platformchkService.isIOS) {
          if(parseInt(version.toString().replace(/\./gi, '')) < parseInt(lastVersion.ios.replace(/\./gi, ''))) {
            await this.versionUpdate('https://apps.apple.com/kr/app/네버랜드/id6745581052');
          }
        }
      }
    }

    const uid: string = localStorage.getItem('userId');
    const user = await this.db.doc$(`user/${uid}`).pipe(first()).toPromise();

    // 로그인 안되어 있는 회원
    if (!uid || !user.uid) {
      this.navCtrl.navigateRoot('/login');
    }
    // 로그인 안되어 있는 회원
    // if (!uid || !user.uid) {
    //   // 로그인 가능한 링크로 올때 로그인 안했으면 비회원용 링크로 보내기 (파라메터 포함)
    //   //main
    //   if(next.url[0]?.path == 'user-tabs' || next.url[0]?.path == 'cel-tabs') {
    //     this.navCtrl.navigateRoot('/visitor-tabs/visitor-main', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //알람
    //   if(next.url[0]?.path == 'alarm') {
    //     this.navCtrl.navigateRoot('/visitor-alarm', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //캐스팅 상세
    //   if(next.url[0]?.path == 'casting') {
    //     this.navCtrl.navigateRoot('/visitor-casting', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //섭외 목록
    //   if(next.url[0]?.path == 'event-list') {
    //     this.navCtrl.navigateRoot('/visitor-casting-list', { queryParams: {castingType: 'off', castingTitle: next.queryParams?.['castingType'] } });
    //     return false;
    //   }
    //   //검색::카테고리 클릭
    //   if(next.url[0]?.path == 'friend-category') {
    //     this.navCtrl.navigateRoot('/visitor-friend-category', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //채팅신청
    //   if(next.url[0]?.path == 'friendtalk-ask') {
    //     this.navCtrl.navigateRoot('/visitor-friendtalk-ask', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //검색
    //   if(next.url[0]?.path == 'search') {
    //     this.navCtrl.navigateRoot('/visitor-search', { queryParams: next.queryParams });
    //     return false;
    //   }
    //   //팬캠 상세
    //   if(next.url[0]?.path == 'square-detail') {
    //     this.navCtrl.navigateRoot('/visitor-square-detail', { queryParams: next.queryParams });
    //     return false;
    //   }

    //   const firstVisit: string = localStorage.getItem('firstVisit') ?? '';
    //   if(firstVisit && firstVisit == 'Y') {
    //     this.navCtrl.navigateRoot('login');
    //     return false;
    //   }else {
    //     localStorage.setItem('firstVisit', 'Y');
    //     this.navCtrl.navigateRoot('/visitor-tabs/visitor-main');
    //     return false;
    //   }
    // }

    if (this.platformchkService.isApp) {
      if (user.dateCreated && user?.device !== this.user.UUID && user.device) {
        await this.alertService
          .cancelOkBtn(
            `${this.translate.instant('common.word.loginExistsConfirm')}`,
            `${this.translate.instant('common.word.cancel')}`,
            `${this.translate.instant('common.word.ok')}`,
            ''
          )
          .then(async ok => {
            if (ok) {
              await this.loginSet(user);
            }else{
              const firstVisit: string = localStorage.getItem('firstVisit') ?? '';
              localStorage.clear();
              if(firstVisit && firstVisit == 'Y') {
                localStorage.setItem('firstVisit', 'Y');
              }
              this.loginCheck = true;
            }
          });
      }
      if(this.loginCheck === true) {
        this.navCtrl.navigateRoot('login');
        return false;
      }
    }
    
    
    if (user.celebApply && !user.celebApproved && !user.celebConfirmed) {
      this.navCtrl.navigateRoot('/waiting-approval', {
        queryParams: {
          type: 'celeb',
        },
      });
      return false;
    } else if (user.companyApply && !user.companyApproved && !user.companyConfirmed) {
      this.navCtrl.navigateRoot('/waiting-approval', {
        queryParams: {
          type: 'company',
        },
      });
      return false;
    } else {
      //로그인 analytics 이벤트 전송
      this.analytics.login(user.uid);

      localStorage.setItem('userType', user.userType);
      if (user.userType == 'company') {
        localStorage.setItem('companyType', user.companyType);
      }

      if (user.userType == 'company' && next.url.length < 1) {
        if (user.companyType == 'celebCompany') {
          this.navCtrl.navigateRoot('/cel-tabs/friend-cel');
          return false;
        } else {
          this.navCtrl.navigateRoot('/user-tabs/home-search');
          return false;
        }
      }

      if (user.userType == 'celeb' && next.url.length < 1) {
        this.navCtrl.navigateRoot('/cel-tabs/friend-cel');
        return false;
      }

      if (user.userType == 'user' && next.url.length < 1) {
        this.navCtrl.navigateRoot('/user-tabs/home-search');
        return false;
      }
      return true;
    }
  }

  // 강제업데이트 알럿
  async versionUpdate(url) {
    const alert = await this.alertController.create({
      cssClass: 'choice-alert ok',
      message: `${this.translate.instant('common.word.needsUpdate')}`,
      backdropDismiss: false,
      buttons: [
        {
          text: '스토어로 이동하기',
          handler: async () => {
            if (this.platformchkService.isApp) {
              await InAppBrowser.openInExternalBrowser({
                  url: url,
              });
            } else {
              window.open(url);
            }
            return false;
          },
        },
      ],
    });
    await alert.present();
  }
}
